/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import React from 'react';
import { token } from '@atlaskit/tokens';
import { type Rendered, type ButtonSetProps } from '@atlassian/forge-ui-types';
import { type Props } from '../..';

export const ButtonSet: React.FunctionComponent<Rendered<ButtonSetProps>> = ({ children }) => (
	<div
		// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		css={css({
			display: 'flex',
			flexWrap: 'wrap',
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
			'> *': { marginTop: token('space.100', '8px'), marginRight: token('space.100', '8px') },
			marginTop: token('space.negative.100', '-8px'),
			marginRight: token('space.negative.100', '-8px'),
		})}
	>
		{children}
	</div>
);

export const ButtonSetFn: React.FunctionComponent<Props> = ({
	children,
	dispatch,
	Components,
	render,
	renderChildren,
}) => <ButtonSet>{renderChildren({ children, dispatch, Components, render })}</ButtonSet>;
